/*
 * Copyright (c) 2023-2025. Haodong JU
 */

import hillo from 'hillo'
import i18n from '@/i18n'
import GlobalConfig, { getNgrokUrl, getOfflineUrl, requireOfflineMode } from '@/model/global/GlobalSettings'
import { cloudUrl, findDeviceByDeviceId } from '@/model/dataLayer/api/SaaS/subscriptionService'

export async function updateSystemBackend () {
  await hillo.jsonPost(cloudUrl + '/virtualDevice/updateBackend', {
    deviceId: GlobalConfig.DeviceId
  })
}

export async function updateOldSystemBackend () {
  await hillo.post('http://innerken.tpddns.cn/PHP/UpdateSelf.php?op=doUpdate', {})
}

export async function getBaseAndUrlForDeviceId (deviceId = '') {
  const url = requireOfflineMode()
    ? getOfflineUrl()
    : deviceId < 6000
      ? getNgrokUrl(deviceId)
      : (await findDeviceByDeviceId(deviceId))
          ?.baseUrl ?? getNgrokUrl(deviceId)
  let tmpDeviceId = deviceId
  if (requireOfflineMode()) {
    tmpDeviceId = await getCurrentDeviceId(getOfflineUrl() + '/PHP/')
  }
  return {
    deviceId: tmpDeviceId,
    url
  }
}

export async function getCurrentDeviceId (prefix = '') {
  try {
    return (await hillo.silentGet(prefix + 'AccessLog.php?op=deviceId')).content ?? GlobalConfig.DeviceId
  } catch (e) {
    return GlobalConfig.DeviceId
  }
}

export async function getInfoForDeviceId (deviceId) {
  const { url } = await getBaseAndUrlForDeviceId(deviceId)
  try {
    return (await hillo.get(url + '/PHP/Restaurant.php?op=view')).content[0]
  } catch (e) {
    // return {name: "店内主机未连接网络", adress1: "无法读取该店铺数据" + counter++}
    return {
      name: i18n.t('Shop_net_error') + ':' + deviceId,
      adress1: i18n.t('cant_get_data') + ':' + deviceId,
      broken: true
    }
  }
}

window.decodeDeviceId = decodeDeviceId

export function decodeDeviceId (str) {
  return pow(BigInt(str), 7n) % 998299n
}

function pow (a, b) {
  let res = a
  for (let i = 1; i < b; i++) {
    res = res * a
  }
  return res
}
